import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_BTN_TEXT](state, p) {
    const drp = p.drp;
    drp.text = p.text;
  },
  [types.SET_BTN_LINK](state, p) {
    const drp = p.drp;
    drp.link = p.link;
  },
};

const actions = {
  setBtnText: ({ commit }, payload) => {
    commit(types.SET_BTN_TEXT, payload);
  },
  setBtnLink: ({ commit }, payload) => {
    commit(types.SET_BTN_LINK, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/button/vuex.js